import React, { useState, useEffect } from 'react';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectColor } from '@panel/commons/core/theme';
import { sendTrackingInfo } from '@panel/commons';
import { ReputationSelectors } from '../../ducks/reputation';
import TooltipHelper from '../../assets/icons/tooltipHelper.svg';
import IconReports from '../../assets/icons/reportsIcon.svg';
import SectionLayout from '../SectionLayout';
import ReportsChart from '../ReportsChart';
import EmptyStateCharts from '../EmptyState';
import { dataReportsAdapter } from '../dataReportsAdapter';
import {
  Container,
  HeaderArea,
  Icon,
  TitleText,
  TooltipComponent,
  IconTooltip,
  MainArea,
  LeftSide,
  ContainerStyled,
  Content,
  ContainerValues,
  Button,
  Separator,
  RightSide
} from './styles';

const Reports = ({ device, reloadDispatch }) => {
  const { t } = useTranslation();
  const [reportsData, setReportsData] = useState(null);
  const { reports, reportsError } = useSelector(ReputationSelectors.getReputationState);
  const { totalReports, newReports, reportsViewed } = reportsData || {};
  const linkToReports = '/panel/avisos?hasReports=true';
  const inColumn = reportsData && reportsData.categories && +reportsData.categories.length > 3;

  useEffect(() => {
    if (reports) setReportsData(dataReportsAdapter(reports));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reports]);

  const reportsCallback = () => {
    if (newReports > 0) {
      sendTrackingInfo('Panel', 'Estadisticas', 'Reputación-Ver reportes');
      window.open(`${window.location.origin}${linkToReports}`, '_self');
    }
  };

  const tooltipComponentHeader = () => {
    return <TooltipComponent>{t(`panel.estadisticas.reports.tooltip`)}</TooltipComponent>;
  };

  const getTopEmptyState = () => {
    if (device === 'mobile') return '20px';
    if (device === 'desktop') return '0px';
    return '30px';
  };

  return (
    <SectionLayout marginTop='0px'>
      <Container>
        <HeaderArea>
          <Icon icon={IconReports} data-panel='panel-estadisticas-reports-icon' />
          <TitleText data-panel='panel-estadisticas-reports-title'>{t('panel.estadisticas.reports.title')}</TitleText>
          <SimpleTooltip
            offset={5}
            backgroundColor={selectColor('black')}
            isMobile={false}
            text={tooltipComponentHeader()}
            position='top-center'
            dataPanel='panel-estadisticas-reports-tooltip'
            allowPlacements='top-end'
            autoPlacements
          >
            <IconTooltip
              src={TooltipHelper}
              alt='tooltip-helper'
              width='16'
              height='16'
              data-panel='panel-estadisticas-reports-icon-tooltip'
            />
          </SimpleTooltip>
        </HeaderArea>
        {!reportsError ? (
          <MainArea device={device} directionColumn={inColumn}>
            <LeftSide device={device}>
              <ContainerStyled>
                <Content data-panel='estadisticas-reports-metrics-container'>
                  <ContainerValues>
                    <div className='value' data-panel='estadisticas-reports-value-new'>
                      {newReports || '0'}
                    </div>
                    <div className='title' data-panel='estadisticas-reports-title-new'>
                      {t('panel.estadisticas.reports.new')}
                    </div>
                  </ContainerValues>
                  <ContainerValues>
                    <div className='value' data-panel='estadisticas-reports-value-viewed'>
                      {reportsViewed || '0'}
                    </div>
                    <div className='title' data-panel='estadisticas-reports-title-viewed'>
                      {t('panel.estadisticas.reports.viewed')}
                    </div>
                  </ContainerValues>
                  <div className='separator' />
                  <ContainerValues bold>
                    <div className='value' data-panel='estadisticas-reports-value-total'>
                      {totalReports || '0'}
                    </div>
                    <div className='title' data-panel='estadisticas-reports-value-total'>
                      {t('panel.estadisticas.reports.total')}
                    </div>
                  </ContainerValues>
                </Content>
              </ContainerStyled>
              <Button
                disabled={!newReports || newReports === 0}
                data-panel='reports-buttonCTA'
                onClick={reportsCallback}
              >
                <div className='text'>{t('panel.estadisticas.reports.goToReports')}</div>
              </Button>
            </LeftSide>
            {device !== 'mobile' && reportsData && (
              <>
                <Separator device={device} directionColumn={inColumn} />
                <RightSide device={device}>
                  <ReportsChart device={device} reportsData={reportsData} inColumn={inColumn} />
                </RightSide>
              </>
            )}
          </MainArea>
        ) : (
          <EmptyStateCharts
            withSpacing={device === 'desktop'}
            height={device === 'mobile' ? '160px' : '115px'}
            top={getTopEmptyState()}
            callback={reloadDispatch}
          />
        )}
      </Container>
    </SectionLayout>
  );
};

export default Reports;
